import { injectExclusionFilter } from 'shared/api/query/exclusion-filter';

export default function useExclusion(selector, model, shouldExclude) {
  const applyExclusion = (queries) => {
    const loadedUids = selector.entityList.value
      .filter((entity) => shouldExclude(entity, { queries }))
      .map((entity) => entity.uid);

    return injectExclusionFilter(queries, loadedUids, model);
  };

  return { applyExclusion };
}
